<div class="flex flex-wrap gap-[24px] px-[40px] pb-[20px] max-laptop:px-[0px] max-mobile:grid-cols-3 max-mobile:grid max-laptop:flex-wrap">
    {#each tags as tag}
        <a class="tag max-mobile:!px-[18px]" href="{`/${lang}/instagram-${tag.text.toLowerCase()}-downloader`}" target="_self">
            <svelte:component this={tag.icon} />
            <span class="txt max-mobile:!text-[14px]">{ $t(`tabs.${tag.text}`) }</span>
        </a>
    {/each}
</div>

<script lang="ts">
    import VideoIcon from "../icons/tag/Video.svelte"
    import PhotoIcon from "../icons/tag/Photo.svelte"
    import ReelIcon from "../icons/tag/Reel.svelte"
    import StoryIcon from "../icons/tag/Story.svelte"
    import PostIcon from "../icons/tag/Post.svelte"
    import IgtvIcon from "../icons/tag/Igtv.svelte"
    import HighlightIcon from "../icons/tag/Highlight.svelte"
    import { t } from "$lib/i18n/translations";
    import locale from "$lib/i18n/locale";
    $: lang = $locale;

  
    // 创建标签数据数组
    const tags = [
        { icon: VideoIcon, text: 'video' },
        { icon: PhotoIcon, text: 'photo'},
        { icon: ReelIcon, text:  'reels'},
        { icon: StoryIcon, text: 'story'},
        { icon: PostIcon, text: 'post'},
        { icon: IgtvIcon, text: 'igtv'},
        { icon: HighlightIcon, text: 'highlights'}
    ];
</script>

<style lang="less">
    .tag {
        padding: 0px 24px;
        height: 48px;
        border-radius: 26px;
        background: rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        .txt {
            color: #000;
            font-size: 18px;
        }
    }
</style>
